// extracted by mini-css-extract-plugin
export default {"main":"Home_main__bEnMm","expirytable":"Home_expirytable__DO5Zn","inventory":"Home_inventory__ttPjO"};